export default __webpack_public_path__ + "static/1662-df2c869d61c1849f87be9ab115fb3980.gif";